/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { getTokenClaims } from "../../../../../app/services/auth.service";
import PersonIcon from "@mui/icons-material/Person";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import Grid from "@mui/material/Grid";
import { REFERENCE_NUMBER } from "../../../../../app/config/cacheKey";
// import { useMutation, useQuery, useQueryClient } from "react-query";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ModalStoreAndBranch from "../../../../../app/components/modals/ModalStoreAndBranch";
export function UserProfileDropdown() {
  const [openModal, setOpenModal] = React.useState(false);
  const { user } = useSelector((state) => state.auth);
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);
  const TOKEN_KEY = "tokenSupplier";
  const handleToken = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem("nameHtmlData", "");
    localStorage.setItem("mobileHtmlData", "");
    // queryClient.setQueryData(REFERENCE_NUMBER, "");
    window.getUserIdGoftino();
  };
  const handleShop = () => {};
  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div
          className={
            "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 divDrop1 "
          }
        >
          {/*<span className="symbol symbol-35 symbol-light-success">
            <span
              style={{ width: "70px" }}
              className="symbol-label font-size-h5 font-weight-bold"
        >*/}
          <PersonIcon className="Icons personIcon" />
          {/* </span>
      </span>*/}
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl divDrop">
        <>
          {!layoutProps.light && (
            <div
              className="d-flex align-items-center justify-content-between flex-wrap p-6 bgi-size-cover bgi-no-repeat rounded-top"
              // style={{
              //   background: `url(${toAbsoluteUrl("/media/bg/bg-8.jpg")})`,
              // }}
            >
              <Grid container spacing={2} className="mTop5">
                <Grid xs={2}>
                  <AccountCircleIcon className="iconProfile colorDefaultFont iconProfileBorder" />
                </Grid>
                <Grid
                  xs={8}
                  style={{ color: "#7FD6FF" }}
                  className=" textFont16"
                >
                  <b>{getTokenClaims()?.fullname}</b>
                  <div className="colorFFF textFont14 colorFFF mTop5 ">
                    {" "}
                    {getTokenClaims()?.phoneNumber}{" "}
                  </div>
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={8}>
                  <b className=" colorUserProfile ">
                    {getTokenClaims()?.supplierName}{" "}
                  </b>
                </Grid>
              </Grid>
              {/* <div className="m-0 flex-grow-1 mr-3 font-size-h5 colorFFF textFont12 col-4">
                         <AccountCircleIcon className="Icons colorTitle marginLeft-15" />
                       </div> */}
              {/* <div className="m-0 flex-grow-1 mr-3 font-size-h5 colorFFF textFont12 col-8">
                         {getTokenClaims()?.supplierName}{" "}
                         <u className="colorFFF textFont12 ">
                           {" "}
                           {getTokenClaims()?.mobileNumber}{" "}
                         </u>
                       </div> */}
              {/* <div className="m-0 flex-grow-1 mr-3 font-size-h5 colorGreen textFont12 col-8 ">
                         <span className="textFont10">
                           {getTokenClaims()?.supplierName}{" "}
                         </span>
                       </div> */}
            </div>
          )}
        </>

        <div className="navi navi-spacer-x-0 ">
          <div className="navi-separator-prrofile"></div>

          <div className="navi-footer  px-8 py-5" onClick={handleShop}>
            <Link
              // to="/#"
              className=" font-weight-bold colorFFF textFont16 "
              onClick={() => setOpenModal(true)}
            >
              <div style={{ display: "inline-block" }}>
                {" "}
                <StoreOutlinedIcon
                  style={{ marginLeft: "20px", fontSize: "2rem" }}
                />
              </div>
              <div style={{ display: "inline-block" }}>
                {" "}
                فروشگاه‌ها و شعبه‌ها
              </div>
            </Link>
          </div>
        </div>
        <div className="navi navi-spacer-x-0 ">
          <div className="navi-separator-prrofile-line"></div>
          <div className="navi-footer  px-8 py-5" onClick={handleToken}>
            <Link
              to="/login"
              className=" font-weight-bold colorFFF textFont16 "
            >
              <div style={{ display: "inline-block" }}>
                {" "}
                <LogoutIcon style={{ marginLeft: "20px", fontSize: "2rem" }} />
              </div>
              <div style={{ display: "inline-block" }}>
                {" "}
                خروج از حساب کاربری
              </div>
            </Link>
          </div>
        </div>
      </Dropdown.Menu>
      <ModalStoreAndBranch openModel={openModal} setOpenModal={setOpenModal} />
    </Dropdown>
  );
}
// const queryClient = useQueryClient();
